

let lastKnownScrollPosition = 0;
let ticking = false;

function doSomething(scrollPos) {
  localStorage.setItem("scrollPos", scrollPos)
}

document.addEventListener('scroll', function(e) {
  lastKnownScrollPosition = window.scrollY;

  if (!ticking) {
    window.requestAnimationFrame(function() {
      doSomething(lastKnownScrollPosition);
      ticking = false;
    });

    ticking = true;
  }
});

window.addEventListener('load', (event) => {
  window.scrollTo(
    0,
    parseFloat(localStorage.getItem("scrollPos") || 0.0)
  )
})
